namespace GeniuzPOS.Inventory {
    export namespace IcStockApproveSetAssembleDtService {
        export const baseUrl = 'Inventory/IcStockApproveSetAssembleDt';

        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockApproveSetAssembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockApproveSetAssembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Delete = "Inventory/IcStockApproveSetAssembleDt/Delete",
            Retrieve = "Inventory/IcStockApproveSetAssembleDt/Retrieve",
            List = "Inventory/IcStockApproveSetAssembleDt/List"
        }

        [
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockApproveSetAssembleDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
